/* calo-opt-sticky-atc.js -- Paket D2-kaufbox (27.09.26)
 * Massnahme R-33 (Teil Sticky-Kaufleiste mobil) und R-35 (klarer naechster Schritt nach
 * "In den Einkaufswagen").
 *
 * 1) Mobile Kaufleiste (<= 767 px): Sorte, Preis, Grundpreis, "inkl. MwSt., zzgl. Versandkosten"
 *    und Button "In den Warenkorb". Sichtbar, solange KEIN Original-Kaufbutton der Seite im
 *    Bild ist (also auch im ersten Screen, bevor der Kunde bis zur Kaufbox scrollt).
 *    Der Button legt NICHTS selbst in den Warenkorb: er klickt den vorhandenen GemPages-Button
 *    "In den Einkaufswagen" (actionEffect continue-shopping). Damit laufen Revy-Properties,
 *    Gratis-Shaker-Guard, Menge, Tracking und Fehlermeldungen exakt wie beim Original.
 *    Preis wird nur aus dem DOM gelesen (GemPages-Preisfeld der gewaehlten Variante), der
 *    Grundpreis aus window.__grundpreise (snippets/grundpreis-anzeige.liquid) bzw. #grundpreis-pangv.
 *    Nichts wird berechnet, Streichpreise werden nicht gezeigt.
 * 2) Hinweis nach erfolgreichem "In den Einkaufswagen" (Event gp:add-to-cart-success von
 *    GemPages): "In den Warenkorb gelegt" + "Zum Warenkorb" / "Weiter einkaufen".
 *    Solange der Hinweis offen ist, wird nur der gruene GemPages-Erfolgs-Toast ausgeblendet
 *    (Fehler-Toasts bleiben sichtbar).
 * Fail-safe: Fehlen Formular, Button oder Preis, passiert nichts und die bisherige Leiste
 * #calo-sticky-bar bleibt wie heute. Die alte Leiste wird nur per CSS-Klasse ausgeblendet,
 * solange diese Leiste einsatzbereit ist (html.calo-opt-satc-an).
 */
(function () {
  'use strict';
  if (window.__caloOptStickyAtc) return;
  window.__caloOptStickyAtc = true;

  var doc = document;
  var html = doc.documentElement;
  var datenEl = doc.getElementById('calo-opt-sticky-atc-daten');
  if (!datenEl) return;
  var D;
  try { D = JSON.parse(datenEl.textContent || '{}'); } catch (e) { return; }
  if (!D || !D.produktId) return;
  D.varianten = D.varianten || {};
  var ANZAHL = 0;
  var LIEFERBAR = false;
  for (var vk in D.varianten) {
    if (Object.prototype.hasOwnProperty.call(D.varianten, vk)) {
      ANZAHL++;
      if (D.varianten[vk] && D.varianten[vk].a) LIEFERBAR = true;
    }
  }
  /* Option heisst "Geschmack"/"Sorte"/... -> Wort "Sorte", sonst neutral "Auswahl" (z. B. Verpackungseinheit) */
  var SORTE = /geschmack|gechmack|sorte|flavo|gew(ä|ae)hlt/i.test(String(D.option || ''));
  var W_WAEHLEN = SORTE ? 'Sorte wählen' : 'Auswahl ändern';

  var mq = window.matchMedia ? window.matchMedia('(max-width: 767px)') : null;
  var reduziert = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var gp = null;          // Haupt-<gp-product> dieser Produktseite
  var t = null;           // seine Teile (Formular, Buttons, Preis, Sortenwahl)
  var bar = null;         // Kaufleiste
  var panel = null;       // Hinweis nach dem Hinzufuegen
  var bereit = false;     // Leiste hat Preis + Button gefunden
  var ziele = [];         // Original-Kaufbuttons, deren Sichtbarkeit beobachtet wird
  var imBild = [];
  var laedt = false;
  var ladeTimer = null;
  var letzterAusloeser = '';
  var panelOffen = false;
  var zuletztFokus = null;
  var toastTimer = null;
  var geplant = false;
  var overlayZuletzt = false;
  var hoeheNeu = true;    // PERF1: Leistenhoehe nur nach Inhaltswechsel neu messen
  var fokusZuletzt = false;

  function el(tag, cls, txt) {
    var e = doc.createElement(tag);
    if (cls) e.className = cls;
    if (txt != null) e.textContent = txt;
    return e;
  }
  function text(e) { return e ? String(e.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  /* GemPages-Einstellungen eines Elements: aelteres Markup im Attribut gp-data='{...}',
     neueres Markup als direktes Kind <script gp-data type="application/json"> (CaloSoup, CaloDrink+) */
  function gpDaten(e) {
    var a = e.getAttribute('gp-data') || '';
    if (a.indexOf('{') > -1) return a;
    for (var k = e.firstElementChild; k; k = k.nextElementSibling) {
      if (k.tagName === 'SCRIPT' && k.hasAttribute('gp-data')) return k.textContent || '';
    }
    return a;
  }
  function effekt(pb) {
    var a = gpDaten(pb);
    var m = /"actionEffect"\s*:\s*"([^"]+)"/.exec(a);
    if (m) return m[1];
    return /^[a-z-]+$/.test(a) ? a : '';
  }
  function mobil() { return !mq || mq.matches; }

  /* ---------- Seite lesen ---------- */
  /* Erstes <gp-product> dieses Produkts mit Formular; gibt es mehrere (z. B. Desktop-/Mobil-Kopie
     beim Shaker), gewinnt das, dessen Kaufbutton tatsaechlich dargestellt wird. */
  function findeHauptprodukt() {
    var list = doc.querySelectorAll('gp-product');
    var erstes = null;
    for (var i = 0; i < list.length; i++) {
      var m = /"productId"\s*:\s*"?(\d+)/.exec(list[i].getAttribute('gp-context') || '');
      if (!m || m[1] !== String(D.produktId) || !list[i].querySelector('form[action*="/cart/add"]')) continue;
      if (!erstes) erstes = list[i];
      var b = list[i].querySelector('button[name="add"]');
      if (b && b.getClientRects().length) return list[i];
    }
    return erstes;
  }
  function teile(g) {
    var r = { form: g.querySelector('form[action*="/cart/add"]'), atc: null, btn: null, pbs: [], preis: null,
      picker: g.querySelector('gp-product-variants') };
    var pbs = g.querySelectorAll('gp-product-button');
    for (var i = 0; i < pbs.length; i++) {
      r.pbs.push(pbs[i]);
      if (!r.atc && effekt(pbs[i]) === 'continue-shopping') r.atc = pbs[i];
    }
    if (r.atc) r.btn = r.atc.querySelector('button[name="add"]') || r.atc.querySelector('button.gp-button-atc');
    var ps = g.querySelectorAll('gp-product-price');
    for (var j = 0; j < ps.length; j++) {
      if (/"priceType"\s*:\s*"regular"/.test(gpDaten(ps[j]))) { r.preis = ps[j]; break; }
    }
    return r;
  }
  function variantenId() {
    var inp = t && t.form ? t.form.querySelector('[name="id"]') : null;
    return inp ? String(inp.value || '') : '';
  }
  function preisText() {
    if (!t || !t.preis) return '';
    var p = text(t.preis.querySelector('.gp-price'));
    return /\d/.test(p) && p.length < 30 ? p : ''; /* kein Preis lesbar -> Leiste bleibt aus */
  }
  function grundpreis(vid) {
    var g = window.__grundpreise;
    if (vid && g && Object.prototype.hasOwnProperty.call(g, vid)) return g[vid] ? String(g[vid]) : '';
    var e = doc.getElementById('grundpreis-pangv');
    if (e && text(e)) return text(e).replace(/^Grundpreis:?\s*/i, '');
    var c = window.__caloOptGP;
    if (vid && c && c[vid]) return String(c[vid]);
    return '';
  }
  function sorte(vid) {
    var v = D.varianten[vid];
    if (ANZAHL < 2 || !v || !v.t || v.t === 'Default Title') return '';
    return String(v.t);
  }
  function addierbar() {
    var vid = variantenId();
    if (!vid || !t || !t.btn) return false;
    var v = D.varianten[vid];
    if (v && v.a === false) return false;
    if (t.btn.disabled) return false;
    if (!t.btn.getClientRects().length) return false; // GemPages blendet den Button bei "ausverkauft" aus
    return true;
  }
  /* Fremdes Overlay offen (Treuepunkte-/Newsletter-Popup, Judge.me-Bewertungsformular, Suche, Menue-
     oder Warenkorb-Drawer)? Dann Leiste ausblenden: sie laege sonst ueber dem Overlay bzw. dessen
     Absende-Button oder waere dahinter nicht klickbar (am 27.09. mit dem Ecomsend-Popup beobachtet). */
  function overlayOffen() {
    if (/(^|\s)overflow-hidden/.test(doc.body.className || '')) return true; /* Dawn: Menue, Suche, Drawer */
    var vh = window.innerHeight || html.clientHeight;
    var ds = doc.querySelectorAll('[aria-modal="true"], dialog[open]');
    for (var i = 0; i < ds.length; i++) {
      var d = ds[i];
      if (d === panel || (bar && bar.contains(d)) || !d.getClientRects().length) continue;
      var cs = window.getComputedStyle(d);
      if (cs.visibility === 'hidden' || cs.display === 'none' || parseFloat(cs.opacity) === 0) continue;
      var r = d.getBoundingClientRect();
      if (r.width > 120 && r.height > 120 && r.bottom > 0 && r.top < vh) return true;
    }
    return false;
  }
  function feldHatFokus() {
    var a = doc.activeElement;
    if (!a || a === doc.body || (bar && bar.contains(a))) return false;
    var tag = a.tagName;
    if (tag === 'TEXTAREA' || tag === 'SELECT' || a.isContentEditable) return true;
    if (tag !== 'INPUT') return false;
    return !/^(hidden|radio|checkbox|button|submit|reset|image)$/i.test(a.type || '');
  }

  /* ---------- Kaufleiste ---------- */
  function baueLeiste() {
    bar = el('div', 'calo-opt-satc');
    bar.id = 'calo-opt-satc';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Schnellkauf');
    bar.setAttribute('data-nosnippet', '');
    bar.setAttribute('aria-hidden', 'true');
    if ('inert' in bar) bar.inert = true;
    var info = el('div', 'calo-opt-satc__info');
    var sBtn = el('button', 'calo-opt-satc__sorte');
    sBtn.type = 'button';
    var sAus = el('span', 'calo-opt-satc__aus', 'Ausverkauft:');
    var sTxt = el('span', 'calo-opt-satc__sorte-txt');
    var sPfeil = el('span', 'calo-opt-satc__pfeil');
    sPfeil.setAttribute('aria-hidden', 'true');
    sPfeil.innerHTML = '<svg width="12" height="12" viewBox="0 0 24 24" focusable="false"><path d="M6 9l6 6 6-6" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    sBtn.appendChild(sAus);
    sBtn.appendChild(sTxt);
    sBtn.appendChild(sPfeil);
    var zeile = el('div', 'calo-opt-satc__preiszeile');
    var preis = el('span', 'calo-opt-satc__preis');
    var gpr = el('span', 'calo-opt-satc__gp');
    zeile.appendChild(preis);
    zeile.appendChild(gpr);
    info.appendChild(sBtn);
    info.appendChild(zeile);
    var kBtn = el('button', 'calo-opt-satc__btn');
    kBtn.type = 'button';
    var kTxt = el('span', 'calo-opt-satc__btn-txt', 'In den Warenkorb');
    kBtn.appendChild(kTxt);
    bar.appendChild(info);
    bar.appendChild(kBtn);
    /* Pflichtangaben-Zeile ueber die volle Breite (auch unter dem Button) */
    if (!D.b2b) bar.appendChild(el('span', 'calo-opt-satc__mwst', 'inkl. MwSt., zzgl. Versandkosten'));
    sBtn.addEventListener('click', zurAuswahl);
    kBtn.addEventListener('click', kaufen);
    doc.body.appendChild(bar);
    bar._u = { sBtn: sBtn, sTxt: sTxt, sAus: sAus, preis: preis, gp: gpr, kBtn: kBtn, kTxt: kTxt };
  }

  function aktualisiere() {
    geplant = false;
    if (!bar || !gp) return;
    /* PERF1: Original-Kaufbutton im Bild und Leiste verborgen -> Leiste bleibt ohnehin aus. Nichts lesen/schreiben
       (addierbar() & Co. erzwingen Layout, bei jedem Sortenwechsel ~5x); der IntersectionObserver ruft
       aktualisiere() erneut auf, sobald der Kaufbutton das Bild verlaesst. */
    if (bereit && !panelOffen && !bar.classList.contains('is-sichtbar')) {
      for (var ib = 0; ib < imBild.length; ib++) if (imBild[ib]) return;
    }
    /* GemPages kann Preis/Button neu rendern -> Teile frisch lesen, sobald ein Knoten nicht mehr im DOM ist */
    if (!doc.contains(t.preis) || !doc.contains(t.btn) || !doc.contains(t.form)) {
      var neu = teile(gp);
      if (neu.form && neu.btn && neu.preis) t = neu;
    }
    var u = bar._u;
    var vid = variantenId();
    var p = preisText();
    var s = sorte(vid);
    var ok = addierbar();
    var g = p ? grundpreis(vid) : '';
    /* PERF1: nur schreiben, was sich geaendert hat (jeder Schreibzugriff erzwingt sonst neues Layout) */
    if (u.preis.textContent !== p) { u.preis.textContent = p; hoeheNeu = true; }
    if (u.gp._g !== g) {
      u.gp._g = g;
      u.gp.textContent = '';
      if (g) {
        var vh = el('span', 'calo-opt-satc__vh', 'Grundpreis ');
        u.gp.appendChild(vh);
        u.gp.appendChild(doc.createTextNode(g));
      }
      hoeheNeu = true;
    }
    u.gp.hidden = !g;
    if (s) {
      if (u.sTxt.textContent !== s) { u.sTxt.textContent = s; hoeheNeu = true; }
      u.sAus.hidden = ok;
      u.sBtn.setAttribute('aria-label', (SORTE ? 'Sorte: ' : 'Auswahl: ') + s + (ok ? '' : ', ausverkauft') + '. ' + (SORTE ? 'Sorte ändern' : 'Auswahl ändern'));
      u.sBtn.hidden = false;
    } else {
      u.sBtn.hidden = true; /* Produkt ohne Sorten: nur Preiszeile (Titel wird bewusst nicht wiederholt) */
    }
    if (!laedt) { var kt = ok ? 'In den Warenkorb' : W_WAEHLEN; if (u.kTxt.textContent !== kt) { u.kTxt.textContent = kt; hoeheNeu = true; } }
    bereit = !!p;
    zeige();
  }
  function planeAktualisierung(ms) {
    setTimeout(function () {
      if (geplant) return;
      geplant = true;
      (window.requestAnimationFrame || setTimeout)(aktualisiere);
    }, ms || 0);
  }

  function zeige() {
    if (!bar) return;
    var aktiv = bereit && mobil();
    html.classList.toggle('calo-opt-satc-an', aktiv); /* blendet die alte Leiste #calo-sticky-bar aus */
    var imBildAnzahl = 0;
    for (var i = 0; i < imBild.length; i++) if (imBild[i]) imBildAnzahl++;
    /* PERF1: Overlay-Pruefung (liest Layout) nur, wenn die Leiste sonst sichtbar waere; Hoehe/Cookie-Button
       nur beim Einblenden bzw. nach Inhaltswechsel messen */
    var kandidat = aktiv && imBildAnzahl === 0 && !panelOffen;
    overlayZuletzt = kandidat ? overlayOffen() : false;
    var sichtbar = kandidat && !overlayZuletzt && !feldHatFokus();
    var war = bar.classList.contains('is-sichtbar');
    if (sichtbar && (!war || hoeheNeu)) {
      if (!war) platzFuerCmp();
      html.style.setProperty('--calo-satc-h', bar.offsetHeight + 'px');
      hoeheNeu = false;
    }
    html.classList.toggle('calo-opt-satc-sichtbar', sichtbar);
    if (war === sichtbar) return;
    bar.classList.toggle('is-sichtbar', sichtbar);
    bar.setAttribute('aria-hidden', sichtbar ? 'false' : 'true');
    if ('inert' in bar) bar.inert = !sichtbar;
  }

  /* Pandectes-Cookie-Button (fixed, ueber allem): Position lesen, damit Leiste und Hinweis ihn
     nicht verdecken. Liefert null, wenn es ihn nicht gibt oder er nicht unten sitzt. */
  function cmpRect() {
    var h = doc.querySelector('pandectes-cmp');
    var w = h && h.shadowRoot ? h.shadowRoot.querySelector('.widget') : null;
    if (!w || !w.getClientRects().length) return null;
    var r = w.getBoundingClientRect();
    var vh = window.innerHeight || html.clientHeight;
    if (!r.width || !r.height || r.top < vh - 160) return null;
    return r;
  }
  function platzFuerCmp() {
    if (!bar) return;
    var r = cmpRect();
    var vw = window.innerWidth || html.clientWidth;
    var rechts = r && r.left > vw / 2 ? Math.round(vw - r.left + 10) : 0;
    var links = r && r.right <= vw / 2 ? Math.round(r.right + 10) : 0;
    bar.style.paddingRight = rechts ? rechts + 'px' : '';
    bar.style.paddingLeft = links ? links + 'px' : '';
  }
  function panelPosition() {
    if (!panel) return;
    var r = cmpRect();
    var vh = window.innerHeight || html.clientHeight;
    panel.style.bottom = r ? Math.round(vh - r.top + 10) + 'px' : '';
  }

  function beobachte() {
    ziele = t.pbs.slice();
    /* Sparbundle-Block (CaloCake, Probierpaket) hat einen eigenen Button: solange er im Bild ist,
       Leiste ausblenden, damit niemand "Bundle gewaehlt" und "Leiste addiert Einzelartikel" verwechselt */
    var bs = doc.getElementById('calo-bundle-full-wrapper');
    if (bs) ziele.push(bs);
    imBild = ziele.map(function () { return false; });
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var k = ziele.indexOf(entries[i].target);
        if (k > -1) imBild[k] = entries[i].isIntersecting;
      }
      aktualisiere();
    }, { threshold: 0 });
    for (var j = 0; j < ziele.length; j++) io.observe(ziele[j]);

    if ('MutationObserver' in window) {
      var mo = new MutationObserver(function () { planeAktualisierung(0); });
      mo.observe(t.preis, { childList: true, subtree: true, characterData: true });
      var inp = t.form.querySelector('[name="id"]');
      if (inp) mo.observe(inp, { attributes: true });
      var btnMo = new MutationObserver(function () {
        if (laedt && t.btn.getAttribute('data-state') === 'idle') ladeStatus(false);
        planeAktualisierung(0);
      });
      btnMo.observe(t.btn, { attributes: true, attributeFilter: ['data-state', 'disabled', 'class'] });
    }
    doc.addEventListener('change', function () { planeAktualisierung(60); planeAktualisierung(400); }, true);
    doc.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('gp-product-variants')) {
        planeAktualisierung(80);
        planeAktualisierung(400);
      }
    }, true);
    /* Cookie-Entscheidung o. ae. kann den Pandectes-Button erst spaeter einblenden */
    doc.addEventListener('click', function () { setTimeout(platzFuerCmp, 700); }, true);
    window.addEventListener('resize', function () { hoeheNeu = true; platzFuerCmp(); });
    /* Popups/Drawer kommen zeitgesteuert oder per Klick und haengen irgendwo im DOM: leichte Abfrage
       (2 Selektoren) alle 700 ms, nur mobil, nur wenn der Tab sichtbar ist; zeige() nur bei Wechsel */
    /* PERF1: nur pruefen, wenn die Leiste ohne Overlay sichtbar waere (Kaufbutton nicht im Bild, kein Hinweis
       offen), und dann in einer Leerlaufphase (requestIdleCallback), nicht mitten in einer Eingabe */
    var leerlauf = window.requestIdleCallback || function (f) { return setTimeout(f, 0); };
    setInterval(function () {
      if (!bar || !bereit || doc.hidden || !mobil() || panelOffen) return;
      for (var i = 0; i < imBild.length; i++) if (imBild[i]) return;
      leerlauf(function () { if (overlayOffen() !== overlayZuletzt) zeige(); }, { timeout: 700 });
    }, 700);
    /* PERF1: bei Fokuswechsel nur neu zeichnen, wenn sich "Eingabefeld hat Fokus" wirklich geaendert hat */
    function fokusWechsel() { var f = feldHatFokus(); if (f !== fokusZuletzt) { fokusZuletzt = f; zeige(); } }
    doc.addEventListener('focusin', function () { setTimeout(fokusWechsel, 0); });
    doc.addEventListener('focusout', function () { setTimeout(fokusWechsel, 0); });
    if (mq) {
      if (mq.addEventListener) mq.addEventListener('change', zeige);
      else if (mq.addListener) mq.addListener(zeige);
    }
  }

  function zurAuswahl(e) {
    if (e && e.preventDefault) e.preventDefault();
    var z = t && (t.picker || t.form);
    if (!z) return;
    var y = z.getBoundingClientRect().top + (window.pageYOffset || 0) - 72; /* Platz fuer den Sticky-Header */
    try { window.scrollTo({ top: Math.max(0, y), behavior: reduziert ? 'auto' : 'smooth' }); }
    catch (err) { window.scrollTo(0, Math.max(0, y)); }
  }

  function ladeStatus(an) {
    laedt = an;
    if (!bar) return;
    var u = bar._u;
    u.kBtn.classList.toggle('is-laedt', an);
    u.kBtn.setAttribute('aria-busy', an ? 'true' : 'false');
    u.kTxt.textContent = an ? 'Wird hinzugefügt …' : (addierbar() ? 'In den Warenkorb' : W_WAEHLEN);
    clearTimeout(ladeTimer);
    if (an) ladeTimer = setTimeout(function () { ladeStatus(false); }, 10000);
  }

  function kaufen(e) {
    if (e && e.preventDefault) e.preventDefault();
    if (laedt || !gp) return;
    t = teile(gp); /* frisch lesen, falls GemPages neu gerendert hat */
    if (!addierbar()) { zurAuswahl(); return; }
    ladeStatus(true);
    letzterAusloeser = 'continue-shopping';
    try {
      t.btn.click(); /* derselbe Klick wie auf "In den Einkaufswagen" */
    } catch (err) {
      ladeStatus(false);
      zurAuswahl();
      return;
    }
    /* GemPages hat den Klick nicht angenommen (z. B. Sorte fehlt) -> Ladezustand sofort loesen */
    setTimeout(function () {
      if (laedt && t.btn.getAttribute('data-state') !== 'loading') ladeStatus(false);
    }, 1500);
  }

  /* ---------- Hinweis nach dem Hinzufuegen (R-35) ---------- */
  function bauePanel() {
    panel = el('div', 'calo-opt-panel');
    panel.id = 'calo-opt-panel';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'false');
    panel.setAttribute('aria-labelledby', 'calo-opt-panel-h');
    panel.setAttribute('data-nosnippet', '');
    panel.setAttribute('aria-hidden', 'true');
    if ('inert' in panel) panel.inert = true;
    var kopf = el('div', 'calo-opt-panel__kopf');
    var h = el('p', 'calo-opt-panel__h');
    h.id = 'calo-opt-panel-h';
    h.tabIndex = -1;
    h.innerHTML = '<svg aria-hidden="true" focusable="false" width="22" height="22" viewBox="0 0 24 24"><circle cx="12" cy="12" r="11" fill="currentColor"/><path d="M7 12.5l3.2 3.2L17 9" fill="none" stroke="#fff" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    h.appendChild(doc.createTextNode('In den Warenkorb gelegt'));
    var x = el('button', 'calo-opt-panel__x');
    x.type = 'button';
    x.setAttribute('aria-label', 'Hinweis schließen');
    x.innerHTML = '<svg aria-hidden="true" focusable="false" width="18" height="18" viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>';
    kopf.appendChild(h);
    kopf.appendChild(x);
    var art = el('p', 'calo-opt-panel__artikel');
    var akt = el('div', 'calo-opt-panel__aktionen');
    var wk = el('a', 'calo-opt-panel__warenkorb', 'Zum Warenkorb');
    wk.href = ROOT.replace(/\/?$/, '/') + 'cart';
    var weiter = el('button', 'calo-opt-panel__weiter', 'Weiter einkaufen');
    weiter.type = 'button';
    akt.appendChild(wk);
    akt.appendChild(weiter);
    panel.appendChild(kopf);
    panel.appendChild(art);
    panel.appendChild(akt);
    x.addEventListener('click', schliessePanel);
    weiter.addEventListener('click', schliessePanel);
    doc.addEventListener('keydown', function (e) {
      if (panelOffen && (e.key === 'Escape' || e.key === 'Esc')) schliessePanel();
    });
    doc.addEventListener('click', function (e) {
      if (!panelOffen || !e.target || panel.contains(e.target)) return;
      if (e.target.closest && e.target.closest('gp-product-button, .calo-opt-satc')) return;
      schliessePanel();
    });
    doc.body.appendChild(panel);
    panel._u = { h: h, art: art };
  }
  /* Nur die Sorte/Variante nennen, nicht den langen Produkttitel (der enthaelt teils Werbeaussagen,
     die gerade rechtlich geprueft werden, R-54) */
  function artikelText(d) {
    var it = d && d.items && d.items.length ? d.items[0] : d;
    if (!it || !it.variant_title || it.variant_title === 'Default Title') return '';
    return String(it.variant_title);
  }
  function oeffnePanel(d) {
    if (!panel) bauePanel();
    var a = artikelText(d);
    panel._u.art.textContent = a;
    panel._u.art.hidden = !a;
    zuletztFokus = doc.activeElement;
    panelOffen = true;
    html.classList.add('calo-opt-panel-offen');
    /* gruenen GemPages-Erfolgs-Toast dieses Klicks unterdruecken, auch wenn der Hinweis schnell
       geschlossen wird (Toast lebt einige Sekunden); Fehler-Toasts bleiben sichtbar */
    html.classList.add('calo-opt-toast-aus');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(toastFreigeben, 8000);
    panel.classList.add('is-offen');
    panel.setAttribute('aria-hidden', 'false');
    if ('inert' in panel) panel.inert = false;
    panelPosition();
    zeige();
    setTimeout(function () {
      try { panel._u.h.focus({ preventScroll: true }); } catch (e) { /* aeltere Browser */ }
    }, 60);
  }
  function toastFreigeben() {
    if (panelOffen) { toastTimer = setTimeout(toastFreigeben, 1000); return; }
    html.classList.remove('calo-opt-toast-aus');
  }
  function schliessePanel() {
    if (!panelOffen) return;
    panelOffen = false;
    html.classList.remove('calo-opt-panel-offen');
    panel.classList.remove('is-offen');
    panel.setAttribute('aria-hidden', 'true');
    if ('inert' in panel) panel.inert = true;
    zeige();
    var z = zuletztFokus;
    zuletztFokus = null;
    if (z && z.focus && doc.contains(z) && z.getClientRects().length) {
      try { z.focus({ preventScroll: true }); } catch (e) { /* egal */ }
    }
  }

  /* Wer hat zuletzt einen GemPages-Kaufbutton ausgeloest? Nur bei "In den Einkaufswagen"
     (continue-shopping) den Hinweis zeigen; "Jetzt kaufen" leitet ohnehin weiter. */
  doc.addEventListener('click', function (e) {
    var pb = e.target && e.target.closest ? e.target.closest('gp-product-button') : null;
    if (pb) letzterAusloeser = effekt(pb);
  }, true);
  window.addEventListener('gp:add-to-cart-success', function (e) {
    var war = letzterAusloeser;
    letzterAusloeser = '';
    if (laedt) ladeStatus(false);
    if (war !== 'continue-shopping') return;
    try { oeffnePanel(e && e.detail ? e.detail.data : null); } catch (err) { /* Hinweis ist nur Zusatz */ }
  });

  /* ---------- Start ---------- */
  function init() {
    if (!LIEFERBAR) return true; /* komplett ausverkauft: keine neue Leiste, alte bleibt */
    gp = findeHauptprodukt();
    if (!gp) return false;
    t = teile(gp);
    if (!t.form || !t.atc || !t.btn || !t.preis) { gp = null; return false; }
    baueLeiste();
    beobachte();
    aktualisiere();
    return true;
  }
  function start() {
    var n = 0;
    (function versuch() {
      var fertig;
      try {
        fertig = init();
      } catch (err) {
        /* Fehler: Leiste entfernen, alte Leiste bleibt sichtbar */
        html.classList.remove('calo-opt-satc-an');
        if (bar && bar.parentNode) bar.parentNode.removeChild(bar);
        bar = null;
        gp = null;
        fertig = true;
      }
      if (!fertig && ++n < 20) setTimeout(versuch, 500);
    })();
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start);
  else start();
})();
